import { combineLatestWith } from 'rxjs';
import useGA from './useGA';
export const useConfigurePlayerGA = (gdk, clientPlat) => {
    const { set, config } = useGA();
    set({
        user_properties: {
            domain: window.location.host,
            client_plat: clientPlat
        }
    });
    gdk.auth.isLoggedIn.pipe(combineLatestWith(gdk.user.data))
        .subscribe(([isLoggedIn, userData]) => {
        if (isLoggedIn) {
            set({ ...config, user_id: userData.account });
            return;
        }
        set({ ...config, user_id: '' });
    });
};
export const useConfigureAgentGA = (gdk) => {
    const { set, config } = useGA();
    set({
        user_properties: {
            domain: window.location.host
        }
    });
    gdk.auth.isLoggedIn.pipe(combineLatestWith(gdk.agent.me))
        .subscribe(([isLoggedIn, me]) => {
        if (isLoggedIn) {
            set({ ...config, user_id: me?.account ?? '' });
            return;
        }
        set({ ...config, user_id: '' });
    });
};
//# sourceMappingURL=useConfigureGA.js.map